import { borderRadiusTokens } from './borderRadius';
import { motionTokens } from './motion';
import { spacingTokens } from './spacing';
import { fontSize, fontStyle, fontWeight, lineHeight, fontFamily } from './typography';
import { zIndex } from './zIndex';
export const defaultTheme = {
    fontSize,
    fontStyle,
    fontWeight,
    lineHeight,
    fontFamily,
    borderRadius: borderRadiusTokens,
    spacing: spacingTokens,
    motion: motionTokens,
    zIndex,
};
